module.exports = __webpack_public_path__ + "officialStatic/img/school6Logo.22324d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school6Logo.png
// module id = E5tX
// module chunks = 0